module.exports = __webpack_public_path__ + "media/vid_body_feature3.60ac60a0.mp4";